export { default } from './ContestView';



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Competitions/ContestView/index.js